import en from "./en";
import ar from "./ar";

const content = {
  en,
  ar,
};

export default content;
